import React, { Fragment, useState, useEffect } from 'react';
import {
    Button,
    Row,
    Modal,
    ModalBody,
    ModalHeader,
    ModalFooter,
    Card,
    CardBody,

} from 'reactstrap';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { NotificationManager } from '../../../../../../components/common/react-notifications';
import {
    gAPI_Property_List_By_Group,
    gAPI_Internal_Property_By_Id,
    dAPI_Delete_Ingetration,
    API_REST_API,
} from '../../../../../../constants/APIs';
import { NavLink } from 'react-router-dom';
import {
    faLanguage, faSms,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import IntegrationInfo from './IntegrationInfo';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import { Colxx, Separator } from '../../../../../../components/common/CustomBootstrap';
import EndPoint from './EndPoint';
import RequestParam from './RequestParam';
import MenuSetting from './MenuSetting';
import FormSetting from './FormSetting';
// import ApiInvocation from './ApiInvocation';
function RESTApiIntegrationList({ match, history, locale, propertyId }) {
    const integrationId = match.params.id;
    const [integration, setIntegration] = useState();
    const [allProperties, setAllProperties] = useState([]);
    const [propertyVisible, setPropertyVisible] = useState(true);
    const [endPointVisible, setFeaturesVisible] = useState(false);
    const [connectWareVisible, setConnectWareVisible] = useState(false);
    const [deleteVisible, setDeleteVisible] = useState(false);
    const [publishVisible, setPublishVisible] = useState(false);
    const [paramVisible, setparamVisible] = useState(false);
    const [menuSetting, setMenuSetting] = useState(false);
    const [voiceAssistantVisible, setVoiceAssistantVisible] = useState(false);
    const [formsVisible, setformsVisible] = useState(false);
    const [propertyData, setPropertyData] = useState([]);


    const menuSettings = () => {
        setMenuSetting(true);
        setPropertyVisible(false);
        setFeaturesVisible(false);
        setConnectWareVisible(false);
        setformsVisible(false);
        setPublishVisible(false);
        setparamVisible(false);
        setVoiceAssistantVisible(false);
    };
    const property = () => {
        setMenuSetting(false);
        setPropertyVisible(true);
        setFeaturesVisible(false);
        setConnectWareVisible(false);
        setformsVisible(false);
        setPublishVisible(false);
        setparamVisible(false);
        setVoiceAssistantVisible(false);
    };

    const connectWareSettings = () => {
        setMenuSetting(false);
        setPropertyVisible(false);
        setFeaturesVisible(false);
        setConnectWareVisible(true);
        setformsVisible(false);
        setPublishVisible(false);
        setparamVisible(false);
        setVoiceAssistantVisible(false);
    }

    const features = () => {
        setMenuSetting(false);
        setPropertyVisible(false);
        setFeaturesVisible(true);
        setConnectWareVisible(false);
        setformsVisible(false);
        setPublishVisible(false);
        setparamVisible(false);
        setVoiceAssistantVisible(false);
    };

    const param = () => {
        setMenuSetting(false);
        setPropertyVisible(false);
        setFeaturesVisible(false);
        setConnectWareVisible(false);
        setformsVisible(false);
        setPublishVisible(false);
        setparamVisible(true);
        setVoiceAssistantVisible(false);
    }


    const voiceAssistant = () => {
        setMenuSetting(false);
        setPropertyVisible(false);
        setFeaturesVisible(false);
        setConnectWareVisible(false);
        setformsVisible(false);
        setPublishVisible(false);
        setparamVisible(false);
        setVoiceAssistantVisible(true);
    }



    const forms = () => {
        setMenuSetting(false);
        setPropertyVisible(false);
        setFeaturesVisible(false);
        setConnectWareVisible(false);
        setformsVisible(true);
        setPublishVisible(false);
        setparamVisible(false);
        setVoiceAssistantVisible(false);
    }


    const publish = () => {
        setMenuSetting(false);
        setPropertyVisible(false);
        setFeaturesVisible(false);
        setConnectWareVisible(false);
        setformsVisible(false);
        setPublishVisible(true);
        setparamVisible(false);
        setVoiceAssistantVisible(false);
    }


    useEffect(() => {
        LoadIntegration();
        AxiosAPI({
            methhod: 'get',
            url: `${gAPI_Internal_Property_By_Id}/${propertyId}?group_id=${getGroupID()}`,
        })
            .then((res) => {

                setPropertyData(res.data);
            })
    }, [integrationId]);
    useEffect(() => {
        AxiosAPI({
            method: 'get',
            url: `${gAPI_Property_List_By_Group}/?group_id=${getGroupID()}`,
        }).then((res) => {
            setAllProperties(res.data);
        });
    }, []);
    const toggle = () => {
        setDeleteVisible(!deleteVisible);
    };
    const LoadIntegration = () => {
        AxiosAPI({
            method: 'get',
            url: `${API_REST_API}/${integrationId}?group_id=${getGroupID()}`,
        })
            .then((res) => {
                setIntegration(res.data);
            })
            .catch((err) => console.log('err', err));
    }

    const updateModel = integration
        ? {
            name: integration.name,
            properties: integration.properties,
            defaultLanguage: 'en-US',
            collectionName: integration.restapiIntegration?.collectionName,
            description: integration.restapiIntegration?.description,
            sessionTimeoutInSeconds: integration.sessionTimeoutInSeconds,
            apiConfigurations: integration.restapiIntegration?.apiConfigurations,
            requestParam: integration.restapiIntegration?.requestParam,
            menuSetting: integration.restapiIntegration?.menuSetting,
            formSetting: integration.restapiIntegration?.formSetting

        }
        : null;

    const saveIntegration = (data) => {
        const { list, name, collectionName, description, apiConfigurations, requestParam, menuSetting, formSetting } = data;
        if (list) {
            updateModel.properties = list;
        }
        if (name) {
            updateModel.name = name;
        }
        if (collectionName) {
            updateModel.collectionName = collectionName;
        }
        if (description) {
            updateModel.description = description;
        }
        if (apiConfigurations) {
            updateModel.apiConfigurations = apiConfigurations;
        }
        if (requestParam) {
            updateModel.requestParam = requestParam
        }
        if (menuSetting) {
            updateModel.menuSetting = menuSetting
        }
        if (formSetting) {
            updateModel.formSetting = formSetting;
        }
        AxiosAPI({
            method: 'put',
            url: `${API_REST_API}/${integration.id}?group_id=${getGroupID()}`,
            data: updateModel,
        })
            .catch((err) => console.error(err))
            .then(() => {
                LoadIntegration();
                NotificationManager.success(
                    "",
                    "Integration update successfully",
                    3000,
                    null,
                    null,
                    "success"
                );
            });
    };
    const handleDelete = () => {
        AxiosAPI({
            method: 'delete',
            url: `${dAPI_Delete_Ingetration}/${integration.id}/?group_id=${getGroupID()}`,
        }).then((res) => {
            toggle();
        });
    };
    const generateDeleteButton = () => {
        return (
            <Row>
                <Colxx xs="12" sm="12" md="12" lg="8" className="mb-4">
                    <Row>
                        <Colxx xs="12" sm="3" className="mb-1">
                            <Modal isOpen={deleteVisible} toggle={toggle}>
                                <ModalHeader toggle={toggle}>
                                    <span role="img" aria-label="warning">
                                        ⚠️
                                    </span>
                                    This integration will be deleted!
                                </ModalHeader>
                                <ModalBody>
                                    <Button
                                        color="danger"
                                        onClick={() => handleDelete()}
                                        size="xs"
                                    >
                                        Delete
                                    </Button>
                                    <Button
                                        className="ml-2"
                                        color="dark"
                                        outline
                                        size="xs"
                                        onClick={toggle}
                                    >
                                        Cancel
                                    </Button>
                                </ModalBody>
                            </Modal>
                        </Colxx>
                    </Row>
                </Colxx>
            </Row>
        );
    };
    return (
        <Fragment>
            {integration ? (
                <Fragment>
                    <Row>
                        <Colxx md="12" sm="12" lg="12" xxs="12">
                            <NavLink to={{ pathname: '/app/pages/integration/applications' }}>
                                <h1 className="iconsminds-back" />
                            </NavLink>
                        </Colxx>
                    </Row>
                    <Row>
                        <Colxx xxs="12" md="6" className="mb-4">
                            <Card>
                                <CardBody>
                                    <div
                                        className={`mb-3 integration ${propertyVisible ? 'integration--active' : ''
                                            }`}
                                    >
                                        <div className="glyph">
                                            <div className={`glyph-icon iconsminds-hotel`} />
                                        </div>
                                        <NavLink
                                            to="#"
                                            className="w-40 w-sm-100"
                                            onClick={(e) => property()}
                                        >
                                            <Row>
                                                <Colxx xxs="12" md="10">
                                                    <p className="list-item-heading mb-1 color-theme-1">
                                                        Select Business
                                                    </p>
                                                    <p className="mb-4 text-small">
                                                        Select the business name for this
                                                        integration
                                                    </p>
                                                </Colxx>
                                                <Colxx xxs="12" md="2">
                                                    <div className="glyph">
                                                        <div
                                                            className={`glyph-icon-min iconsminds-arrow-forward-2`}
                                                        />
                                                    </div>
                                                </Colxx>
                                            </Row>
                                        </NavLink>
                                        <Separator />
                                    </div>

                                    <div
                                        className={`mb-3 integration ${endPointVisible ? 'integration--active' : ''
                                            }`}
                                    >
                                        <div className="glyph">
                                            <div className={`glyph-icon simple-icon-link`} />
                                        </div>
                                        <NavLink
                                            to="#"
                                            className="w-40 w-sm-100"
                                            onClick={(e) => features()}
                                        >
                                            <Row>
                                                <Colxx xxs="12" md="10">
                                                    <p className="list-item-heading mb-1 color-theme-1">
                                                        Requests
                                                    </p>
                                                    <p className="mb-4 text-small">
                                                        Integrate to any external API to post or get the data
                                                    </p>
                                                </Colxx>
                                                <Colxx xxs="12" md="2">
                                                    <div className="glyph">
                                                        <div
                                                            className={`glyph-icon-min iconsminds-arrow-forward-2`}
                                                        />
                                                    </div>
                                                </Colxx>
                                            </Row>
                                        </NavLink>
                                        <Separator />
                                    </div>

                                    <div
                                        className={`mb-3 integration ${paramVisible ? 'integration--active' : ''
                                            }`}
                                    >
                                        <div className="glyph">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" style={{ fill: `${paramVisible ? 'var(--theme-color-1)' : 'black'}` }}>
                                                <path d="M9 22h1v-2h-.989C8.703 19.994 6 19.827 6 16c0-1.993-.665-3.246-1.502-4C5.335 11.246 6 9.993 6 8c0-3.827 2.703-3.994 3-4h1V2H8.998C7.269 2.004 4 3.264 4 8c0 2.8-1.678 2.99-2.014 3L2 13c.082 0 2 .034 2 3 0 4.736 3.269 5.996 5 6zm13-11c-.082 0-2-.034-2-3 0-4.736-3.269-5.996-5-6h-1v2h.989c.308.006 3.011.173 3.011 4 0 1.993.665 3.246 1.502 4-.837.754-1.502 2.007-1.502 4 0 3.827-2.703 3.994-3 4h-1v2h1.002C16.731 21.996 20 20.736 20 16c0-2.8 1.678-2.99 2.014-3L22 11z"></path></svg>
                                        </div>
                                        <NavLink
                                            to="#"
                                            className="w-40 w-sm-100"
                                            onClick={(e) => param()}
                                        >
                                            <Row>
                                                <Colxx xxs="12" md="10">
                                                    <p className="list-item-heading mb-1 color-theme-1">
                                                        Input Params
                                                    </p>
                                                    <p className="mb-4 text-small">
                                                        List of value to be used when calling the API requests
                                                    </p>
                                                </Colxx>
                                                <Colxx xxs="12" md="2">
                                                    <div className="glyph">
                                                        <div
                                                            className={`glyph-icon-min iconsminds-arrow-forward-2`}
                                                        />
                                                    </div>
                                                </Colxx>
                                            </Row>
                                        </NavLink>
                                        <Separator />
                                    </div>

                                    <div
                                        className={`mb-3 integration ${menuSetting ? 'integration--active' : ''
                                            }`}
                                    >
                                        <div className="glyph">
                                            <div className={`glyph-icon iconsminds-three-arrow-fork`} />
                                        </div>
                                        <NavLink
                                            to="#"
                                            className="w-40 w-sm-100"
                                            onClick={(e) => menuSettings()}
                                        >
                                            <Row>
                                                <Colxx xxs="12" md="10">
                                                    <p className="list-item-heading mb-1 color-theme-1">
                                                        Manage Web Widget Menus
                                                    </p>
                                                    <p className="mb-4 text-small">
                                                        Choose the menu items you want to display based on API results
                                                    </p>
                                                </Colxx>
                                                <Colxx xxs="12" md="2">
                                                    <div className="glyph">
                                                        <div
                                                            className={`glyph-icon-min iconsminds-arrow-forward-2`}
                                                        />
                                                    </div>
                                                </Colxx>
                                            </Row>
                                        </NavLink>
                                        <Separator />
                                    </div>
                                    <div
                                        className={`mb-3 integration ${formsVisible ? 'integration--active' : ''
                                            }`}
                                    >
                                        <div className="glyph">
                                            <div className={`glyph-icon iconsminds-book`} />
                                        </div>
                                        <NavLink
                                            to="#"
                                            className="w-40 w-sm-100"
                                            onClick={(e) => forms()}
                                        >
                                            <Row>
                                                <Colxx xxs="12" md="10">
                                                    <p className="list-item-heading mb-1 color-theme-1">
                                                        Form Integrations
                                                    </p>
                                                    <p className="mb-4 text-small">
                                                        Connect your form to API`s
                                                    </p>
                                                </Colxx>
                                                <Colxx xxs="12" md="2">
                                                    <div className="glyph">
                                                        <div
                                                            className={`glyph-icon-min iconsminds-arrow-forward-2`}
                                                        />
                                                    </div>
                                                </Colxx>
                                            </Row>
                                        </NavLink>
                                        <Separator />
                                    </div>
                                    {/* <div
                                        className={`mb-3 integration ${publishVisible ? 'integration--active' : ''
                                            }`}
                                    >
                                        <div className="glyph">
                                            <div className={`glyph-icon iconsminds-monitor---tablet`} />
                                        </div>
                                        <NavLink
                                            to="#"
                                            className="w-40 w-sm-100"
                                            onClick={(e) => publish()}
                                        >
                                            <Row>
                                                <Colxx xxs="12" md="10">
                                                    <p className="list-item-heading mb-1 color-theme-1">
                                                        Publish your AI Voice Assistant
                                                    </p>
                                                    <p className="mb-4 text-small">
                                                        Setup the forwarding rules in ConnectWare
                                                    </p>
                                                </Colxx>
                                                <Colxx xxs="12" md="2">
                                                    <div className="glyph">
                                                        <div
                                                            className={`glyph-icon-min iconsminds-arrow-forward-2`}
                                                        />
                                                    </div>
                                                </Colxx>
                                            </Row>
                                        </NavLink>
                                        <Separator />
                                    </div> */}
                                    <div>
                                        <Button
                                            color="dark"
                                            outline
                                            style={{
                                                width: '100%',
                                                borderRadius: '6px',
                                            }}
                                            className="mb-4"
                                            onClick={toggle}
                                        >
                                            Archive
                                        </Button>

                                        <Separator />
                                    </div>
                                </CardBody>
                            </Card>
                        </Colxx>
                        <Colxx xxs="12" md="6" className="mb-4">
                            {propertyVisible && (
                                <Fragment>
                                    <IntegrationInfo
                                        integration={integration}
                                        saveIntegration={saveIntegration}
                                        integrationProperties={integration.properties === null ? [] : integration.properties}
                                        allProperties={allProperties}
                                    />
                                    {/* <Example url="https://assets.bookmebob.com/images/integration-example/properties.png" /> */}
                                </Fragment>
                            )}

                            {endPointVisible && (
                                <Fragment>
                                    <EndPoint
                                        id={integration.id}
                                        settings={integration?.restapiIntegration}
                                        saveIntegration={saveIntegration}
                                        integrationProperties={integration.properties}
                                        allProperties={allProperties}
                                    />
                                </Fragment>)}

                            {paramVisible && (
                                <Fragment>
                                    <RequestParam
                                        settings={integration?.restapiIntegration}
                                        saveIntegration={saveIntegration}
                                        integrationProperties={integration.properties}
                                        allProperties={allProperties}
                                    />
                                </Fragment>)}

                            {formsVisible && (
                                <Fragment>
                                    <FormSetting
                                        settings={integration?.restapiIntegration}
                                        saveIntegration={saveIntegration}
                                        lang={locale}
                                        integrationProperties={integration.properties}
                                        allProperties={allProperties}
                                        propertyId={integration.properties[0]}
                                    />
                                </Fragment>)}

                            {menuSetting && (
                                <Fragment>
                                    <MenuSetting
                                        settings={integration?.restapiIntegration}
                                        saveIntegration={saveIntegration}
                                        propertyId={integration.properties[0]}
                                        lang={locale}
                                        integrationProperties={integration.properties}
                                        allProperties={allProperties}
                                    />
                                </Fragment>)}
                        </Colxx>
                    </Row >
                </Fragment >
            ) : null
            }
            {generateDeleteButton()}
        </Fragment >
    );
}
const mapStateToProps = ({ settings }) => {
    const { propertyId, locale } = settings;
    return {
        propertyId, locale
    };
};

export default injectIntl(connect(mapStateToProps, {})(RESTApiIntegrationList));